export default {"src":"https://static.spiritory.com/_next/static/media/auth6.26fc1eb1.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};